import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { siteInfo } from "@/mocks/site";

const aboutJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AboutPage",
      name: "关于我们 - 爆料在线",
      url: "https://mtx360.cn/about",
      description: "了解爆料在线的品牌定位、内容原则、发展理念与联系方式。",
    },
    {
      "@type": "Organization",
      name: "爆料在线",
      email: "contact@baoliao-online.example.com",
      url: "https://mtx360.cn/",
      description: "专注独家内容的爆料资讯门户，输出首发猛料、内幕消息与独家调查。",
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://mtx360.cn/" },
        { "@type": "ListItem", position: 2, name: "关于我们", item: "https://mtx360.cn/about" },
      ],
    },
  ],
};

export default function AboutPage() {
  return (
    <SiteLayout>
      <Seo
        title="关于我们 - 爆料在线｜独家内容的核实标准与内容原则"
        description="了解爆料在线的品牌定位、内容原则、发展理念与联系方式。我们坚持先核实后发布，公开信息链路，做经得起追问的独家内容。"
        keywords="关于爆料在线,爆料在线介绍,内容原则,独家调查,微八卦"
        canonical="https://mtx360.cn/about"
        type="website"
        jsonLd={aboutJsonLd}
      />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
          <Breadcrumb items={[{ label: "关于我们" }]} />
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-7">
              <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                关于爆料在线
              </p>
              <h1 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
                别人看到热闹，我们看清门道
              </h1>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                {siteInfo.intro}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                自 {siteInfo.since} 年起，我们从几条深夜的独家快讯出发，逐步搭建起「快讯—解读—调查」三层内容结构。我们相信爆料的价值不在速度本身，而在于它是否经得起追问。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/category/exclusive"
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
                >
                  <i className="ri-fire-line" aria-hidden="true" />
                  看独家猛料
                </Link>
                <a
                  href={`mailto:${siteInfo.tipEmail}`}
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600"
                >
                  <i className="ri-mail-send-line" aria-hidden="true" />
                  提供线索
                </a>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="grid grid-cols-2 gap-4">
                {siteInfo.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="rounded-lg border border-background-200 bg-background-50 p-5"
                  >
                    <p className="font-heading text-2xl font-black text-primary-600">{stat.value}</p>
                    <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section aria-labelledby="position-title" className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h2 id="position-title" className="font-heading text-2xl font-black text-foreground-950">
              我们要做什么
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              在一个信息以秒计数的环境里，我们选择把「核实」放在「抢先」前面。这不是保守，而是对读者时间的尊重。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {siteInfo.principles.map((item) => (
              <article
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${item.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section aria-labelledby="timeline-title" className="border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
          <h2 id="timeline-title" className="font-heading text-2xl font-black text-foreground-950">
            我们怎么走到今天
          </h2>
          <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
            从单条快讯到完整调查，栏目在变，判断标准没变。
          </p>
          <ol className="mt-8 space-y-0">
            {siteInfo.timeline.map((item, index) => (
              <li key={item.year} className="relative flex gap-5 pb-8 last:pb-0">
                <div className="flex flex-col items-center">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
                    {item.year}
                  </span>
                  {index < siteInfo.timeline.length - 1 && (
                    <span className="mt-1 w-px flex-1 bg-background-300" />
                  )}
                </div>
                <div className="pt-2">
                  <p className="text-sm leading-relaxed text-foreground-700">{item.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section aria-labelledby="voice-title" className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
        <h2 id="voice-title" className="font-heading text-2xl font-black text-foreground-950">
          行业里的人怎么看我们
        </h2>
        <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-3">
          {siteInfo.voices.map((voice) => (
            <blockquote
              key={voice.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{voice.text}</p>
              <footer className="mt-5 border-t border-background-200 pt-4">
                <p className="font-heading text-sm font-bold text-foreground-950">{voice.name}</p>
                <p className="mt-0.5 text-xs text-secondary-600">{voice.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </section>

      <section id="contact" aria-labelledby="contact-title" className="mx-auto w-full max-w-shell px-4 pb-16 md:px-6 md:pb-20">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
          <h2 id="contact-title" className="font-heading text-2xl font-black text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            无论是有价值的线索、内容层面的质疑，还是合作意向，我们都欢迎你用邮件与我们联系。
          </p>
          <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            <a
              href={`mailto:${siteInfo.tipEmail}`}
              className="group flex cursor-pointer items-start gap-3 rounded-lg border border-background-200 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-megaphone-line text-xl" aria-hidden="true" />
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground-950">爆料线索</span>
                <span className="mt-1 block text-xs text-foreground-600">{siteInfo.tipEmail}</span>
              </span>
            </a>
            <a
              href={`mailto:${siteInfo.email}`}
              className="group flex cursor-pointer items-start gap-3 rounded-lg border border-background-200 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-mail-line text-xl" aria-hidden="true" />
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground-950">合作与更正</span>
                <span className="mt-1 block text-xs text-foreground-600">{siteInfo.email}</span>
              </span>
            </a>
            <div className="flex items-start gap-3 rounded-lg border border-background-200 p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className="ri-time-line text-xl" aria-hidden="true" />
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground-950">值守时间</span>
                <span className="mt-1 block text-xs text-foreground-600">每日 09:00 - 次日 01:00</span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}